export class IndividualViewBase {
    id: number;
    displayName: string;
    profileImageUrl: string  = null;
    gender: string;
    givenName: string;
  }